import React, { ReactNode } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth'; 
import SlSpinner from "@shoelace-style/shoelace/dist/react/spinner"

interface PermissionRouteProps {
  children: ReactNode;
  module: string;
  permission?: string;
}

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <SlSpinner style={{ fontSize: "2rem" }} />
  </div>
);

export const PermissionRoute = ({ 
  children, 
  module, 
  permission = "acceso_a_ruta" 
}: PermissionRouteProps): JSX.Element => {
  const { hasPermission, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (!hasPermission(module, permission)) {
    return <Navigate to="/sin-permisos" replace />;
  }

  return <>{children}</>;
};